// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"ApolloLoadingContent_spinnerWrapper__QeLpJ","errorWrapper":"ApolloLoadingContent_errorWrapper__19ejU"};